import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './TableInfo.css';
import { useTableById } from '../../api/tables';
import ReservationDetailsModal from '../../Screens/ReservationDetails/ReservationDetails';

const TableInfo = ({ tableId, reservations, selectedDate, onClose, tables }) => {
  const { data, isLoading } = useTableById(tableId);
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const [selectedReservationGuestId, setSelectedReservationGuestId] = useState(null);

  const tableReservations = reservations.filter(res =>
    res.tableIds.includes(tableId) && res.time.startsWith(selectedDate)
  );

  const handleEdit = (reservation) => {
    setSelectedReservationId(reservation.id);
    setSelectedReservationGuestId(reservation.guest_id || null);
  };

  React.useEffect(() => {
    if (selectedReservationId) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [selectedReservationId]);

  if (isLoading) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: 'clamp(320px, 90vw, 480px)',
            maxWidth: '100%',
            maxHeight: '80%',
            overflowY: 'auto',
            background: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            padding: 'clamp(1.5rem, 3vw, 2rem)',
            fontFamily: "'Inter', 'Arial', sans-serif",
            animation: 'modal-slideIn 0.3s ease-out',
          }}
        >
          <style>
            {`
              @keyframes modal-slideIn {
                from {
                  transform: translate(-50%, calc(-50% - 20px));
                  opacity: 0;
                }
                to {
                  transform: translate(-50%, -50%);
                  opacity: 1;
                }
              }
              @keyframes pulse {
                0% { opacity: 1; }
                50% { opacity: 0.6; }
                100% { opacity: 1; }
              }
            `}
          </style>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
              color: '#6b7280',
              transition: 'color 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#374151')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            ✕
          </button>
          {/* Skeleton Title */}
          <div
            style={{
              height: '24px',
              width: '60%',
              background: '#e5e7eb',
              borderRadius: '4px',
              marginBottom: '16px',
              animation: 'pulse 1.5s infinite',
            }}
          ></div>
          {/* Skeleton Reservation Items */}
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              style={{
                borderBottom: '1px solid #e5e7eb',
                padding: 'clamp(0.75rem, 1.5vw, 1rem) 0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  flex: 1,
                }}
              >
                <div
                  style={{
                    height: '16px',
                    width: '50%',
                    background: '#e5e7eb',
                    borderRadius: '4px',
                    marginBottom: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                ></div>
                <div
                  style={{
                    height: '14px',
                    width: '40%',
                    background: '#e5e7eb',
                    borderRadius: '4px',
                    marginBottom: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                ></div>
                <div
                  style={{
                    height: '14px',
                    width: '30%',
                    background: '#e5e7eb',
                    borderRadius: '4px',
                    animation: 'pulse 1.5s infinite',
                  }}
                ></div>
              </div>
              <div
                style={{
                  height: '36px',
                  width: '80px',
                  background: '#e5e7eb',
                  borderRadius: '6px',
                  animation: 'pulse 1.5s infinite',
                }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: 'clamp(320px, 90vw, 480px)',
            maxWidth: '100%',
            maxHeight: '80%',
            overflowY: 'auto',
            background: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            padding: 'clamp(1.5rem, 3vw, 2rem)',
            fontFamily: "'Inter', 'Arial', sans-serif",
            animation: 'modal-slideIn 0.3s ease-out',
          }}
        >
          <style>
            {`
              @keyframes modal-slideIn {
                from {
                  transform: translate(-50%, calc(-50% - 20px));
                  opacity: 0;
                }
                to {
                  transform: translate(-50%, -50%);
                  opacity: 1;
                }
              }
            `}
          </style>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 'clamp(1.25rem, 2vw, 1.5rem)',
              color: '#6b7280',
              transition: 'color 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#374151')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            ✕
          </button>
          <h2
            style={{
              color: '#3fb488',
              fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
              fontWeight: 500,
              margin: '0 0 16px',
            }}
          >
            Резервации за маса број {data.display_number || tableId}
          </h2>
          {tableReservations.length === 0 ? (
            <p
              style={{
                color: '#374151',
                fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
                fontWeight: 500,
                margin: '0',
              }}
            >
              Нема резервации за оваа маса.
            </p>
          ) : (
            tableReservations.map(reservation => (
              <div
                key={reservation.id}
                style={{
                  borderBottom: '1px solid #e5e7eb',
                  padding: 'clamp(0.75rem, 1.5vw, 1rem) 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  transition: 'background-color 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div>
                  <p
                    style={{
                      color: '#374151',
                      fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
                      fontWeight: 500,
                      margin: '0 0 4px',
                    }}
                  >
                    <strong>{reservation.name}</strong>
                  </p>
                  <p
                    style={{
                      color: '#6b7280',
                      fontSize: 'clamp(0.75rem, 1vw, 0.875rem)',
                      margin: '0 0 4px',
                    }}
                  >
                    Време: {new Date(reservation.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                  </p>
                  <p
                    style={{
                      color: '#6b7280',
                      fontSize: 'clamp(0.75rem, 1vw, 0.875rem)',
                      margin: 0,
                    }}
                  >
                    Број на луѓе: {reservation.partySize}
                  </p>
                </div>
                <button
                  onClick={() => handleEdit(reservation)}
                  style={{
                    padding: 'clamp(0.5rem, 1vw, 0.625rem) clamp(1rem, 2vw, 1.25rem)',
                    backgroundColor: '#3fb488',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: 'clamp(0.875rem, 1.2vw, 1rem)',
                    fontWeight: 500,
                    transition: 'background-color 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#2f8a66';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#3fb488';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  Отвори
                </button>
              </div>
            ))
          )}
        </div>
      </div>
      {selectedReservationId &&
        createPortal(
          <ReservationDetailsModal
            reservationId={selectedReservationId}
            guestID={selectedReservationGuestId}
            tables={[tableId]}
            onClose={() => setSelectedReservationId(null)}
          />,
          document.body
        )}
    </>
  );
};

export default TableInfo;